<div class="footer black-bg-color" [ngClass]="{'pl-100' :(router.url.includes('/stream/') || router.url.includes('/watch/'))}">

        <div fxLayout="row wrap"  fxLayoutAlign="center center" 
            class="Flinks">

            <div fxFlex="30%" fxFlex.xs="100%" fxFlex.md="40%" fxFlex.sm="60%">
                    <!-- <a routerLink="/faq" routerLinkActive="faq-text" class="pointer">FAQ</a> -->
                    <a routerLink="/termsandconditions" routerLinkActive="faq-text" class="pointer">Terms of Service</a>
                    <a routerLink="/cookiepolicy" routerLinkActive="faq-text" class="pointer">Cookie Policy</a>
                    <a routerLink="/privacypolicy" routerLinkActive="faq-text" class="pointer">Privacy Policy</a>
                    <a routerLink="/contactus" routerLinkActive="faq-text" class="pointer">Contact Us</a>
                    <!-- <a routerLink="/aboutus" routerLinkActive="faq-text" class="pointer">About Us</a> -->
  
            </div>
            <div fxFlex="30%" fxFlex.xs="100%" fxFlex.md="40%" fxFlex.sm="40%">

                <div  class="Fcopy">&copy;{{copyRightYear}} - {{clientDetails.name}} Inc. All rights reserved.
                </div>
            </div>
            <div fxFlex="20%" fxFlex.xs="100%" fxFlex.md="20%" fxFlex.sm="100%" class="text-right">
                <div class="Fsocial" >
                    <!-- <a matTooltipPosition="above" matTooltip="Facebook"
                        href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank"><i
                            class="fa fa-facebook-f"></i></a> -->
                    <a matTooltipPosition="above" matTooltip="Linkedin" href="https://www.linkedin.com/company/bigbee-ai/" target="_blank">
                        <i class="fa fa-linkedin fs-20" aria-hidden="true"></i>
                    </a>
                    <!-- <a matTooltipPosition="above" matTooltip="Twitter" href="https://twitter.com/areveatv"
                        target="_blank"><i class="fa fa-twitter active-color"></i></a>
                    <a matTooltipPosition="above" matTooltip="Instagram" href="https://www.instagram.com/areveatv/"
                        target="_blank"><i class="fa fa-instagram"></i></a> -->
                </div>
            </div>
            <div fxFlex="20%" fxFlex.xs="100%" fxFlex.md="40%" fxFlex.sm="60%">
                <!-- <img [src]="assets_url + 'Powered-By.svg'" width="100" class="mb-3" (click)="redirectTo()"> -->
                <span class="mb-3" (click)="redirectTo()"><app-svg [icon]="'powered-by-bb'"></app-svg></span>
            </div>
        </div>

        <!-- <div class="fixed" fxLayout="row" *ngIf="userInfo?.id">
            <div fxFlex="20%" fxFlex.sm="5%"></div>
            <div fxFlex="45%" fxFlex.sm="50%">&copy;{{copyRightYear}} - AreveaTV Inc. All rights reserved.</div>
            <div fxFlex="20%" fxFlex.sm="25%">
                <a (click)="redirectPage('termsandconditions')" class="pointer">Terms & Conditions</a>
            </div>
            <div fxFlex="15%" fxFlex.sm="20%">
                <a (click)="redirectPage('privacypolicy')" class="pointer">Privacy</a>
            </div>
        </div> -->
    </div>